import { render, staticRenderFns } from "./TendersFiltersChips.vue?vue&type=template&id=61adcb62"
import script from "./TendersFiltersChips.vue?vue&type=script&lang=js"
export * from "./TendersFiltersChips.vue?vue&type=script&lang=js"
import style0 from "./TendersFiltersChips.vue?vue&type=style&index=0&id=61adcb62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports